const goneStockPages = [
  '/stocks/A-stock',
  '/stocks/AAL-stock',
  '/stocks/AAPL-stock',
  '/stocks/ABBV-stock',
  '/stocks/ABNB-stock',
  '/stocks/ABT-stock',
  '/stocks/ACGL-stock',
  '/stocks/ACN-stock',
  '/stocks/ADBE-stock',
  '/stocks/ADI-stock',
  '/stocks/ADM-stock',
  '/stocks/ADP-stock',
  '/stocks/ADSK-stock',
  '/stocks/AEE-stock',
  '/stocks/AEP-stock',
  '/stocks/AES-stock',
  '/stocks/AFL-stock',
  '/stocks/AIG-stock',
  '/stocks/AIZ-stock',
  '/stocks/AJG-stock',
  '/stocks/AKAM-stock',
  '/stocks/ALB-stock',
  '/stocks/ALGN-stock',
  '/stocks/ALK-stock',
  '/stocks/ALL-stock',
  '/stocks/ALLE-stock',
  '/stocks/AMAT-stock',
  '/stocks/AMCR-stock',
  '/stocks/AMD-stock',
  '/stocks/AME-stock',
  '/stocks/AMGN-stock',
  '/stocks/AMP-stock',
  '/stocks/AMT-stock',
  '/stocks/AMZN-stock',
  '/stocks/ANET-stock',
  '/stocks/ANSS-stock',
  '/stocks/AON-stock',
  '/stocks/AOS-stock',
  '/stocks/APA-stock',
  '/stocks/APD-stock',
  '/stocks/APH-stock',
  '/stocks/APTV-stock',
  '/stocks/ARE-stock',
  '/stocks/ATO-stock',
  '/stocks/AVB-stock',
  '/stocks/AVGO-stock',
  '/stocks/AVY-stock',
  '/stocks/AWK-stock',
  '/stocks/AXON-stock',
  '/stocks/AXP-stock'
]

export default function(ctx) {
  const { route } = ctx

  const normalizedPath = route.path.replace(/\/$/, '')

  if (goneStockPages.includes(normalizedPath)) {
    const err = new Error('Gone')
    err.response = { status: 410, data: {} }
    ctx.app.$error(err)
  }
}
